module.exports = __webpack_public_path__ + "static/media/1029882.8aabc15e.png";